const agenda = [
  {
    time: "10:00 AM",
    title: "Registration & Welcome Tea",
    desc: "Delegates arrive and are received. Introductory networking over refreshments.",
    highlight: false,
  },
  {
    time: "10:30 AM",
    title: "Opening Address",
    desc: "Welcome by CA Adv Harsh Patel (Water & Shark) and Mr. Sujit S Nair (EICBI) - Setting the diplomatic and business context.",
    highlight: false,
  },
  {
    time: "10:45 AM",
    title: "Keynote Address",
    speaker: "H.E. Mr. Evagoras Vryonides",
    role: "High Commissioner, Republic of Cyprus to India",
    desc: "Cyprus Presidency: Priorities for EU-India Engagement - Strategic insights on the Cyprus Presidency of the EU Council and its implications for Indian businesses.",
    highlight: true,
  },
  {
    time: "11:30 AM",
    title: "Special Policy & Business Dialogue",
    desc: "Structured interactive session examining EU-India Free Trade Agreement, bilateral trade expansion, regulatory cooperation, and investment frameworks.",
    highlight: false,
  },
  {
    time: "12:15 PM",
    title: "Closed-Door Q&A Session",
    desc: "Direct engagement with the High Commissioner - By Invitation Only. A rare opportunity for delegates to seek policy clarity directly from EU diplomatic leadership.",
    highlight: true,
  },
  {
    time: "12:45 PM",
    title: "Exclusive Networking Luncheon",
    desc: "Curated closed-door networking over a formal luncheon with fellow industry leaders, policy experts, and diplomatic guests.",
    highlight: false,
  },
  {
    time: "1:00 PM",
    title: "Formal Conclusion",
    desc: "Closing remarks and next steps for EU-India business collaboration.",
    highlight: false,
  },
];

export default function AgendaSection() {
  return (
    <section id="agenda" data-testid="agenda-section" className="section-dark py-24 lg:py-32 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p className="overline-gold mb-3">Programme of the Day</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl lg:text-4xl text-white font-medium">
            27 April 2026 &nbsp;&middot;&nbsp; DoubleTree by Hilton
          </h2>
          <div className="gold-divider w-48 mx-auto mt-5" />
        </div>

        <div className="relative" data-testid="agenda-timeline">
          <div className="absolute left-[11px] top-6 bottom-6 w-px bg-gradient-to-b from-[#D4AF37] to-transparent" />

          <div className="flex flex-col gap-0">
            {agenda.map((item) => (
              <div
                key={item.time}
                data-testid={`agenda-item-${item.time.replace(/[:\s]/g, "-")}`}
                className="relative flex gap-6 pb-10 last:pb-0"
              >
                <div className="timeline-dot mt-1">
                  <div className="timeline-dot-inner" />
                </div>

                <div className={`flex-1 ${item.highlight ? "glass-card p-6 border-[#D4AF37]/35" : ""}`}>
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="overline-gold text-[0.65rem]">{item.time}</span>
                    {item.highlight && (
                      <span className="text-[0.58rem] bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/25 px-2 py-0.5 tracking-wider uppercase font-semibold">
                        Featured
                      </span>
                    )}
                  </div>
                  <h3 className="font-['Cormorant_Garamond'] text-xl text-white font-medium mb-1">
                    {item.title}
                  </h3>
                  {item.speaker && (
                    <p className="text-[#D4AF37] text-xs font-['Outfit'] font-semibold mb-1">
                      {item.speaker} &nbsp;&middot;&nbsp; <span className="text-[#94A3B8] font-normal">{item.role}</span>
                    </p>
                  )}
                  <p className="text-[#94A3B8] text-sm font-['Outfit'] leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
